export async function asyncDelay(ms: number) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}
